export const environment = {
  production: true,
  API: 'https://app.followcencosud.com/api/v1/',
  SOCKET_URL: 'https://app.followcencosud.com/',
  SOCKET_PATH: null,
  SENTRY_URL: 'http://27a382351e3c416aabbd28af758941e0@sentry.zooft.company/3',
  ADFS_ONLY: false,
  WS_TRANSPORT: 'websocket',
  RELEASE_VERSION: null,
  API_KEY: null,
  DISABLED_COOKIE: false
};